import { EventEmitter } from "events";

class AutocareEventBus extends EventEmitter {
  private static instance: AutocareEventBus;

  private constructor() {
    super();
  }

  public static getInstance() {
    if (!AutocareEventBus.instance) {
      AutocareEventBus.instance = new AutocareEventBus();
    }
    return AutocareEventBus.instance;
  }
}

const eventBus = AutocareEventBus.getInstance();
export default eventBus;
